<template>
<div>
	<div class="header-index">
		<div class="index-header-wrapper">
			<div class="index-header">
				<a href="#" class="logo">
					<img src="../indexComponent/img/mainlogo.png">
					<span>快贷</span>
				</a>
				<ul class="index-nav">
					<router-link tag="li" :to="{path: '/index'}">首页</router-link>
					<!-- <router-link tag="li" :to="{path: '/expect',query:{'order_status':1}}">产品服务</router-link> -->
					<router-link tag="li" :to="{path: '/antiFraud'}">反欺诈</router-link>
					<router-link tag="li" :to="{path: '/assetsPricing'}">资产定价</router-link>
					<!-- <router-link tag="li" :to="{path: '/expect',query:{'order_status':2}}">坏账揽收</router-link> -->
					<!-- <router-link tag="li" :to="{path: '/expect',query:{'order_status':3}}">资金供给</router-link> -->
					<router-link tag="li" :to="{path: '/aboutUs'}">关于我们</router-link>
					<router-link tag="li" :to="{path: '/joinUs'}">加入我们</router-link>
					<router-link tag="li" :to="{path: '/download',query:{'order_status':4}}">产品下载</router-link>
				</ul>
				<div class="index-button">
					<span @click="openLayer">申请接入</span>
					<span @click="login">商家登录</span>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
	export default{
		data(){
			return {

			}
		},
		methods: {
			login,
			openLayer,
		},
	}


	function openLayer(){
		this.$message({
			showClose: true,
			message: '正在努力开发中,敬请期待',
			type: 'success',
			duration: 1000
		});
	}


	function login(){
		// location.href = 'http://admin.test.senqiang.cn';
		location.href = this.$store.state.adminUrl;
	}
</script>
<style lang="scss">
	.index-header-wrapper{
		position: fixed;
		top: 0;
		z-index: 999;
		width: 100%;
		height: 56px;
		background: #19202D;
		border-bottom: 1px solid rgba(255,255,255,0.1);
		&:hover{
			background: #2A303C;
		}
		.index-header{
			max-width: 1120px;
			margin: 0 auto;
			color: #fff;
			line-height: 56px;
			overflow: hidden;
			.logo{
				float: left;
				padding-left: 18px;
				img{
					width: 32px;
					height: auto;
					vertical-align: sub;
				}
				span{
					font-size: 16px;
					color: #FFFFFF;
					line-height: 14px;
					display: inline-block;
					border-left: 1px solid #fff;
					padding-left: 5px;
					margin-left: 3px;
				}
			}
			.index-nav{
				float: left;
				display: flex;
				margin-left: 60px;
				li{
					font-size: 14px;
					color: #fff;
					line-height: 14px;
					cursor: pointer;
					padding: 21px 12px;
					&.router-link-exact-active.router-link-active{
						color: #366EFB;
						border-bottom: 2px solid #366EFB;
						padding-bottom: 19px;
					}
				}
			}
			.index-button{
				float: right;
				padding-right: 18px;
				span{
					width: 90px;
					height: 30px;
					font-size: 14px;
					color: #fff;
					border: 1px solid #fff;
					display: inline-block;
					border-radius: 3px;
					text-align: center;
					line-height: 30px;
					margin-left: 14px;
					cursor: pointer;
					&:last-child{
						background: #366efb;
						border: 1px solid #366efb;
					}
				}
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue